import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input, Dropdown, Form } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { TRANSLATION_FILES } from '../../constants/translation';

class SearchFilter extends Component {
  static propTypes = {
    filterName: PropTypes.string.isRequired,
    filterInName: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onSearchInChange: PropTypes.func,
    onClear: PropTypes.func.isRequired,
    search: PropTypes.string,
    searchIn: PropTypes.string,
    placeholder: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object),
    isFullSize: PropTypes.bool,
    t: PropTypes.func,
    label: PropTypes.string,
  }
  static defaultProps = {
    filterName: 'search',
    filterInName: 'searchIn',
    isLoading: false,
    placeholder: 'Search',
  }
  static getPropsToState = (props) => {
    const search = props.search || '';
    let searchIn = props.searchIn || '';
    if (props.options && props.options.length > 0 && (!searchIn || searchIn === '')) {
      searchIn = props.options[0].value;
    }
    return {
      search,
      searchIn,
    };
  }
  constructor(props) {
    super(props);
    const state = SearchFilter.getPropsToState(props);
    this.state = state;
  }
  componentDidMount() {
    this.waitForDropdownMenu();
    window.addEventListener('resize', this.syncDropdownMenuWidth);
  }
  componentWillReceiveProps(nextProps) {
    const state = SearchFilter.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.syncDropdownMenuWidth);
    clearInterval(this.dropdownPollInterval);
  }
  waitForDropdownMenu = () => {
    this.dropdownPollInterval = setInterval(() => {
      const menu = document.querySelector('.uc-search-dropdown .menu');
      if (menu && menu.offsetParent !== null) { // check it's visible
        clearInterval(this.dropdownPollInterval);
        this.syncDropdownMenuWidth();
      }
    }, 50);
  };
  syncDropdownMenuWidth = () => {
    const inputWrapper = document.querySelector('.uc-search-wrapper');
    const dropdown = document.querySelector('.uc-search-dropdown');
    const dropdownMenu = document.querySelector('.uc-search-dropdown .menu');

    if (inputWrapper && dropdown && dropdownMenu) {
      const inputRect = inputWrapper.getBoundingClientRect();
      const dropdownRect = dropdown.getBoundingClientRect();
      const leftOffset = dropdownRect.left - inputRect.left;

      dropdownMenu.style.minWidth = `${inputWrapper.offsetWidth}px`;
      dropdownMenu.style.left = `-${leftOffset}px`;
    }
  };
  handleClear = () => {
    this.setState({ search: '' }, () => {
      const { onClear, filterName } = this.props;
      if (onClear) {
        onClear(filterName);
      }
    });
  }
  handleSearch = (e) => {
    if (e) { e.preventDefault(); }
    if (this.state.search === '' && this.props.search !== '') {
      this.handleClear();
    } else if (this.state.search) {
      this.props.onChange(this.state.search, this.props.filterName);
    }
  }
  handleBlur = () => {
    // Call submit manually
    this.handleSearch();
  };
  handleOnChange = (e) => {
    const search = e.target.value;
    this.setState({ search }, () => {
      if (search === '') {
        this.handleClear();
      }
    });
  }
  handleOnDropdownChange = (e, { value }) => {
    this.setState({ searchIn: value }, () => {
      this.props.onSearchInChange(value, this.props.filterInName);
    });
  }
  render() {
    const { t } = this.props;
    const isRenderInputAction = this.props.options && this.props.options.length > 0 && this.state.searchIn;
    return (
      <Form onSubmit={this.handleSearch}>
        <div className="field">
          <label htmlFor="search">{this.props.label}</label>
          <Input
            className={`uc-search-wrapper ${isRenderInputAction ? 'uc-with-dropdown' : 'uc-no-dropdown'}`}
            loading={this.props.isLoading}
            disabled={this.props.isLoading}
            name="search"
            onChange={this.handleOnChange}
            placeholder={t(this.props.placeholder)}
            value={this.state.search}
            {...(isRenderInputAction && { action: true })}
          >
            <input onBlur={this.handleBlur} />
            {this.props.options && this.props.options.length > 0 &&
              <Dropdown
                selection
                floating
                className="uc-search-dropdown"
                style={{ textAlign: 'right' }}
                onChange={this.handleOnDropdownChange}
                options={this.props.options}
                disabled={this.props.isLoading}
                value={this.state.searchIn}
                name="searchIn"
              />
            }
          </Input>
        </div>
      </Form>
    );
  }
}

export default withTranslation(TRANSLATION_FILES.screens)(SearchFilter);



// WEBPACK FOOTER //
// ./src/components/UpdatedComponents/UCSearchIn.jsx